"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationSessionType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class PronunciationSessionType {
    constructor(userId, questionCount, moduleId, materialIds) {
        this.duration = 0;
        this.currentQuestionIndex = 0;
        this.userId = userId;
        this.questionCount = questionCount;
        this.moduleId = moduleId;
        this.materialIds = materialIds;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_PRONUNCIATION_SESSION;
    }
}
exports.PronunciationSessionType = PronunciationSessionType;
